import { render, staticRenderFns } from "./resource-select.vue?vue&type=template&id=38cfdee2&scoped=true&"
import script from "./resource-select.ts?vue&type=script&lang=ts&"
export * from "./resource-select.ts?vue&type=script&lang=ts&"
import style0 from "./resource-select.scss?vue&type=style&index=0&id=38cfdee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cfdee2",
  null
  
)

export default component.exports